import MediaGrid from './MediaGrid';
import MediaSlider from './MediaSlider';

import { MEDIA_TYPE_HOTEL_IMAGE } from '@hotels-hotel-detail/utils/hotel-images';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';

type Props = {
  hotelId: string;
};

const HotelMedia = ({ hotelId }: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isActive: boolean) =>
      isActive ? (
        <MediaSlider hotelId={hotelId} />
      ) : (
        <MediaGrid mediaType={MEDIA_TYPE_HOTEL_IMAGE} hotelId={hotelId} />
      )
    }
  </BpkBreakpoint>
);

export default HotelMedia;
